import Link from "next/link";
import type { ComponentProps, ReactNode } from "react";

type Variant = "primary" | "secondary" | "ghost";

const variantCls: Record<Variant, string> = {
  primary: "btn-silver active:translate-y-px",
  secondary: "btn-glass active:translate-y-px",
  ghost:
    "text-[var(--color-mist)] hover:bg-[color-mix(in_oklab,var(--color-surface-2)_60%,transparent)] hover:text-[var(--color-paper)] hover:backdrop-blur-sm",
};

const sizeCls = {
  sm: "px-3.5 py-1.5 text-[13px]",
  md: "px-5 py-2.5 text-sm",
  lg: "px-6 py-3 text-[15px]",
};

const base =
  "inline-flex items-center justify-center gap-2 rounded-[var(--radius-pill)] font-medium transition-colors duration-200 whitespace-nowrap disabled:opacity-50 disabled:pointer-events-none";

/** 链接按钮 */
export function ButtonLink({
  href,
  variant = "primary",
  size = "md",
  className = "",
  children,
  ...rest
}: {
  href: string;
  variant?: Variant;
  size?: keyof typeof sizeCls;
  className?: string;
  children: ReactNode;
} & Omit<ComponentProps<typeof Link>, "href" | "className">) {
  return (
    <Link href={href} className={`${base} ${variantCls[variant]} ${sizeCls[size]} ${className}`} {...rest}>
      {children}
    </Link>
  );
}

/** 动作按钮 */
export function Button({
  variant = "primary",
  size = "md",
  className = "",
  children,
  ...rest
}: {
  variant?: Variant;
  size?: keyof typeof sizeCls;
  className?: string;
  children: ReactNode;
} & ComponentProps<"button">) {
  return (
    <button className={`${base} ${variantCls[variant]} ${sizeCls[size]} ${className}`} {...rest}>
      {children}
    </button>
  );
}
